import React from "react";
import { Route } from "react-router-dom";
import { BrowserRouter, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";

import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import ApplicationProcessing from './pages/application-processing';
import DealershipManagement from './pages/dealership-management';
import VoucherVerification from './pages/voucher-verification';
import VoucherVerificationPublic from './pages/voucher-verification-public';
import DealershipLandingPage from './pages/dealership-landing-page';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import AnalyticsDashboard from './pages/analytics-dashboard';
import LegalImprint from './pages/legal-imprint';
import CustomerPortal from './pages/customer-portal';
import TermsAndConditionsAGB from './pages/terms-and-conditions-agb';
import PrivacyPolicy from './pages/privacy-policy';
import ApplicationSuccess from './pages/application-success';
import Homepage from './pages/homepage';
import ConfirmRegistration from './pages/confirm-registration';
import ComplianceReports from './pages/compliance-reports';
import MonitoringDashboard from './pages/monitoring-dashboard';
import PartnerFinder from './pages/partner-finder';
import PartnerCategoriesManagement from './pages/partner-categories-management';

const router = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/application-processing" element={<ApplicationProcessing />} />
          <Route path="/dealership-management" element={<DealershipManagement />} />
          <Route path="/voucher-verification" element={<VoucherVerification />} />
          <Route path="/verify-voucher/:token" element={<VoucherVerificationPublic />} />
          <Route path="/application-success" element={<ApplicationSuccess />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/impressum" element={<LegalImprint />} />
          <Route path="/terms-and-conditions-agb" element={<TermsAndConditionsAGB />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/customer-portal" element={<CustomerPortal />} />
          <Route path="/confirm-registration" element={<ConfirmRegistration />} />
          <Route path="/compliance-reports" element={<ComplianceReports />} />
          <Route path="/monitoring-dashboard" element={<MonitoringDashboard />} />
          <Route path="/partner-finder" element={<PartnerFinder />} />
          <Route path="/partner-categories-management" element={<PartnerCategoriesManagement />} />
          <Route path="/:dealershipSlug/gutscheincheck" element={<VoucherVerificationPublic />} />
          <Route path="/:dealershipSlug" element={<DealershipLandingPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </ErrorBoundary>
  </BrowserRouter>
);

export default router;